"use client";

import { Input } from "@headlessui/react";
import { debounce } from "lodash";
import { useEffect, useMemo, useState } from "react";

const SelectDetailsPatient = ({
  onSearchChange,
  placeholder = "Zoeken",
  search = "",
}) => {
  const [draftSearch, setDraftSearch] = useState(search);

  const debouncedSearch = useMemo(
    () => debounce((value) => onSearchChange?.(value), 350),
    [onSearchChange]
  );

  useEffect(() => {
    setDraftSearch(search);
  }, [search]);

  useEffect(() => () => debouncedSearch.cancel(), [debouncedSearch]);

  return (
    <div className="w-full min-w-0">
      <Input
        placeholder={placeholder}
        className="block h-11 w-full rounded-xl border border-wa-border bg-wa-panel2 py-2.5 pl-3 pr-3 text-sm text-wa-text outline-none ring-0 placeholder:text-wa-text/55 focus:border-wa-accent focus:ring-1 focus:ring-wa-accent sm:text-sm/6"
        value={draftSearch}
        onChange={(event) => {
          const nextSearch = event.target.value;
          setDraftSearch(nextSearch);
          debouncedSearch(nextSearch);
        }}
      />
    </div>
  );
};

export default SelectDetailsPatient;
